import style from './destination-carousel.module.less';
import useCommonProps, { BaseComponent } from '../../hooks/useCommonProps';
import {
  GalleryCardProps,
  GalleryCardComponent,
} from '@vaad1st/component.molecule.gallery-card';
import {
  CarouselComponent,
  CarouselConfiguration,
} from '@vaad1st/component.organism.carousel';

export interface DestinationCarouselProps extends BaseComponent {
  destinations: GalleryCardProps[];
}

export const DestinationCarouselComponent = ({
  destinations,
  testId = 'destination-carousel-component',
  testAttribute,
  testAttributeValue,
}: DestinationCarouselProps) => {
  const commonProps = useCommonProps({
    testId,
    testAttribute,
    testAttributeValue: testAttributeValue || testId,
  });

  if (!destinations || destinations.length < 1) {
    return null;
  }

  return (
    <section
      className={style['destination-carousel-component']}
      aria-label="Destinations"
      {...commonProps}
    >
      <CarouselComponent
        controlsConfig={{ arrows: true, byScreen: true, byDrag: false }}
        configuration={CarouselConfiguration.Heavy}
      >
        {destinations.map((destination) => (
          <GalleryCardComponent {...destination} key={destination.title} />
        ))}
      </CarouselComponent>
    </section>
  );
};
